module.exports = __webpack_public_path__ + "9170894094e6f97e7b00e99d8954a839.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/samsung_gear_connect/logo-mmr.png
// module id = 1843
// module chunks = 1